// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    font-family: sans-serif;
    box-sizing: border-box;
  }
  
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  
  .text-center {
    text-align: center;
  }
  
  .color-white {
    color: #fff;
  }
  
  .box-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 35px 5px;
    width: 100%;
  }
  
  @media screen and (min-width: 1380px) {
    .box-container {
      flex-direction: row;
    }
  }
  
  .box-item {
    position: relative;
    -webkit-backface-visibility: hidden;
    width: 415px;
    margin-bottom: 35px;
    max-width: 100%;
  }
  
  .flip-box {
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
    perspective: 1000px;
    -webkit-perspective: 1000px;
  }
  
  .flip-box-front,
  .flip-box-back {
    background-size: cover;
    background-position: center;
    border-radius: 84px;
    border:2px solid rgb(63, 62, 62 , 0.6);
    min-height: 475px;
    transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    -webkit-transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    backface-visibility: hidden;
  }
  
  .flip-box-front {
    transform: rotateY(0deg);
    transform-style: preserve-3d;
  }
  
  .flip-box:hover .flip-box-front {
    transform: rotateY(-180deg);
    transform-style: preserve-3d;
  }
  
  .flip-box-back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transform: rotateY(180deg);
    transform-style: preserve-3d;
  }
  
  .flip-box:hover .flip-box-back {
    transform: rotateY(0deg);
    transform-style: preserve-3d;
  }
  
  .flip-box .inner {
    position: absolute;
    left: 0;
    width: 100%;
    padding: 60px;
    outline: 1px solid transparent;
    perspective: inherit;
    z-index: 2;
  
    transform: translateY(-50%) translateZ(120px) scale(0.94);
    -webkit-transform: translateY(-50%) translateZ(120px) scale(0.94);
    -ms-transform: translateY(-50%) translateZ(120px) scale(0.94);
    top: 50%;
  }
  
  .flip-box-header {
    font-size: 34px;
  }
  
  .flip-box p {
    font-size: 14px;
    line-height: 1.5em;
  }
  
  .flip-box-img {
    margin-top: 25px;
  }
  
  .flip-box-button {
    background-color: transparent;
    border: 2px solid #ffffff9b;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: bold;
    margin-top: 35px;
    padding: 15px;
    text-transform: uppercase;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/FlipBox.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE,kBAAkB;IAClB,mCAAmC;IACnC,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IAEE,4BAA4B;IAC5B,oCAAoC;IACpC,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,sCAAsC;IACtC,iBAAiB;IAEjB,yDAAyD;IACzD,iEAAiE;IAEjE,2BAA2B;EAC7B;;EAEA;IAGE,wBAAwB;IAGxB,4BAA4B;EAC9B;;EAEA;IAGE,2BAA2B;IAG3B,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IAIX,0BAA0B;IAG1B,4BAA4B;EAC9B;;EAEA;IAGE,wBAAwB;IAGxB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,aAAa;IACb,8BAA8B;IAE9B,oBAAoB;IACpB,UAAU;;IAEV,yDAAyD;IACzD,iEAAiE;IACjE,6DAA6D;IAC7D,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;EAC3B","sourcesContent":["html {\r\n    font-family: sans-serif;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  *,\r\n  *:before,\r\n  *:after {\r\n    box-sizing: inherit;\r\n  }\r\n  \r\n  .text-center {\r\n    text-align: center;\r\n  }\r\n  \r\n  .color-white {\r\n    color: #fff;\r\n  }\r\n  \r\n  .box-container {\r\n    align-items: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-around;\r\n    padding: 35px 5px;\r\n    width: 100%;\r\n  }\r\n  \r\n  @media screen and (min-width: 1380px) {\r\n    .box-container {\r\n      flex-direction: row;\r\n    }\r\n  }\r\n  \r\n  .box-item {\r\n    position: relative;\r\n    -webkit-backface-visibility: hidden;\r\n    width: 415px;\r\n    margin-bottom: 35px;\r\n    max-width: 100%;\r\n  }\r\n  \r\n  .flip-box {\r\n    -ms-transform-style: preserve-3d;\r\n    transform-style: preserve-3d;\r\n    -webkit-transform-style: preserve-3d;\r\n    perspective: 1000px;\r\n    -webkit-perspective: 1000px;\r\n  }\r\n  \r\n  .flip-box-front,\r\n  .flip-box-back {\r\n    background-size: cover;\r\n    background-position: center;\r\n    border-radius: 84px;\r\n    border:2px solid rgb(63, 62, 62 , 0.6);\r\n    min-height: 475px;\r\n    -ms-transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);\r\n    transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);\r\n    -webkit-transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);\r\n    -webkit-backface-visibility: hidden;\r\n    backface-visibility: hidden;\r\n  }\r\n  \r\n  .flip-box-front {\r\n    -ms-transform: rotateY(0deg);\r\n    -webkit-transform: rotateY(0deg);\r\n    transform: rotateY(0deg);\r\n    -webkit-transform-style: preserve-3d;\r\n    -ms-transform-style: preserve-3d;\r\n    transform-style: preserve-3d;\r\n  }\r\n  \r\n  .flip-box:hover .flip-box-front {\r\n    -ms-transform: rotateY(-180deg);\r\n    -webkit-transform: rotateY(-180deg);\r\n    transform: rotateY(-180deg);\r\n    -webkit-transform-style: preserve-3d;\r\n    -ms-transform-style: preserve-3d;\r\n    transform-style: preserve-3d;\r\n  }\r\n  \r\n  .flip-box-back {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n  \r\n    -ms-transform: rotateY(180deg);\r\n    -webkit-transform: rotateY(180deg);\r\n    transform: rotateY(180deg);\r\n    -webkit-transform-style: preserve-3d;\r\n    -ms-transform-style: preserve-3d;\r\n    transform-style: preserve-3d;\r\n  }\r\n  \r\n  .flip-box:hover .flip-box-back {\r\n    -ms-transform: rotateY(0deg);\r\n    -webkit-transform: rotateY(0deg);\r\n    transform: rotateY(0deg);\r\n    -webkit-transform-style: preserve-3d;\r\n    -ms-transform-style: preserve-3d;\r\n    transform-style: preserve-3d;\r\n  }\r\n  \r\n  .flip-box .inner {\r\n    position: absolute;\r\n    left: 0;\r\n    width: 100%;\r\n    padding: 60px;\r\n    outline: 1px solid transparent;\r\n    -webkit-perspective: inherit;\r\n    perspective: inherit;\r\n    z-index: 2;\r\n  \r\n    transform: translateY(-50%) translateZ(120px) scale(0.94);\r\n    -webkit-transform: translateY(-50%) translateZ(120px) scale(0.94);\r\n    -ms-transform: translateY(-50%) translateZ(120px) scale(0.94);\r\n    top: 50%;\r\n  }\r\n  \r\n  .flip-box-header {\r\n    font-size: 34px;\r\n  }\r\n  \r\n  .flip-box p {\r\n    font-size: 14px;\r\n    line-height: 1.5em;\r\n  }\r\n  \r\n  .flip-box-img {\r\n    margin-top: 25px;\r\n  }\r\n  \r\n  .flip-box-button {\r\n    background-color: transparent;\r\n    border: 2px solid #ffffff9b;\r\n    border-radius: 10px;\r\n    color: #fff;\r\n    cursor: pointer;\r\n    font-size: 0.9rem;\r\n    font-weight: bold;\r\n    margin-top: 35px;\r\n    padding: 15px;\r\n    text-transform: uppercase;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
